import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import no from '../../Assets/Images/Login/no.svg'
import search from '../../Assets/Images/BuscarCotizacion/search.svg'
import { ReactComponent as IconCarrito } from '../../Assets/Images/Generals/carrito_entrega.svg'
import { ReactComponent as ShopCarrito } from '../../Assets/Images/Generals/shop.svg'
import './rightSetLocationModal.css'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import es from 'dayjs/locale/es'
import { CircularProgress, ClickAwayListener, TextField } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { t } from 'i18next'
import { ID_CONSTANTS } from 'redux/types'
import {
  generateDispatchOrderAction,
  validateAmountOnCommercialCredit,
} from 'redux/actions/sellOrderActions'
import SellOrderDeliveryWarning from 'Components/SellOrderDeliveryWarning'
import CheckDeliveryCostsModal from 'Components/CheckDeliveryCostsModal'
import CheckIsDDAvaliableModal from 'Components/CheckIsDDAvaliableModal'
import {
  fullfilmentPlanActionByDelivery,
  supplierAction,
} from 'redux/actions/catalogActions'
import {
  ROUTES,
  customerTypeId,
  dispatchTypeId,
  salesOrderTypeIds,
  VAPermissions,
  companiesCodeOracle,
  DEFAULT_PHONE_PREFIX,
} from 'Utils/constants'
import styles from './rightSetLocationModal.module.css'
import Loading from 'Components/Loading'
import useValidatePermission from 'Hooks/useValidatePermission'
import { useDebounce } from 'Hooks/useDebounce'
import { useValidateLocation } from './hooks/useValidateLocation'
import { removeDuplicateProducts } from './utils/removeDuplicateProducts'
import { AddressOption } from './components/AddressOption'
import { postNotifyDispatch } from 'Api/services/busServices'
import {
  searchInfoBranchId,
  getCustomerById,
} from 'redux/actions/clientsActions'
import Locker from './components/Locker'
import { updateSlotService } from 'Api/services/cuartServices'
import CustomSnackbar from 'Components/CustomSnackbar' // Entrega Directa D1
import { Formatter } from 'Utils/Formatter'
import PhoneNumberField from 'Views/Clientes/CrearCliente/components/PhoneNumberField/PhoneNumberField'
import { useOrderAllocation } from 'Hooks/useOrderAllocation'
import ModalAlertGeneric from 'Components/ModalAlertGeneric/ModalAlertGeneric'
import { validatorIsCountedCustomer } from 'Utils/functions'

const directDelivertSupplier =
  ID_CONSTANTS.fullFilmentData.fullFilmentDirectDeliveryProviderID // Entrega Directa Proveedor
const directDeliveryD1 = ID_CONSTANTS.fullFilmentData.directDeliveryD1ID

const defaultSupplier = {
  fulfillmentPlanId: directDeliveryD1,
  fulfillmentPlanDescription: 'ENTREGA DIRECTA D1',
}

function RightSetLocationModal({
  handleOpen,
  open,
  deployAddAddres,
  branchesData,
  data,
  isDirectDelivery,
  setIsDirectDelivery,
  listOfNewCosts,
  webOdvDetails,
  comments,
  showEditAddress,
  promisedDate,
  setPromisedDate,
  fulfillmentPlanIdSelected = null,
  deliveryMethodODV,
}) {
  const dispatchQtyState = data
  const dispatch = useDispatch()
  const { checkSelectedLocation } = useValidateLocation()
  const [openDropdown, setOpenDropdown] = useState({
    selectBranchOffice: false,
    dispatchTypeBranchOffice: false,
    dispatchTypeDomicile: false,
    selectSupplier: false,
  })
  const { fullfilmentResponse } = useSelector(state => state.catalog)
  const [location, setLocation] = useState(null)
  const [seeMoreState, setSeeMoreState] = useState(false)
  const [deliveryMethodState, setDeliveryMethodState] = useState(null)
  const [formDataMerchandise, setFormDataMerchandise] = useState({
    retirement: 'isCustomer',
    fullName: '',
    phone: { Prefix: DEFAULT_PHONE_PREFIX, number: '' },
    comment: '',
  })

  const [showDeliveryTypeState, setShowDeliveryTipeState] = useState(false)
  const [deliveryTypeState, setDeliveryTypeState] = useState(null)
  const [showSucState, setShowSucState] = useState(false)
  const [sucState, setSucState] = useState(null)
  const [supplier, setSupplier] = useState(null)
  const [deliveryDateState, setDeliveryDateState] = useState(
    promisedDate ? dayjs(promisedDate) : null
  )
  const history = useHistory()
  const [isNotValidDelivState, setIsNotValidDelivState] = useState(false)
  const [isNotValidCostState, setIsNotValidCostState] = useState(false)
  const [isNotValidDDProductState, setIsNotValidDDProductState] =
    useState(false)

  const [isErrorDispatchModal, setIsErrorDispatchModal] = useState(false)
  const [messageDispatchModal, setMessageDispatchModal] = useState({
    message: '',
    status: '',
  })
  const [isErrorComercialCreditModal, setIsErrorComercialCreditModal] =
    useState(false)
  const [
    isErrorMessageComercialCreditModal,
    setIsErrorMessageComercialCreditModal,
  ] = useState({
    message: '',
    status: '',
  })

  const [isErrorLimitCreditModal, setIsErrorLimitCreditModal] = useState(false)
  const [isErrorMessageLimitCreditModal, setIsErrorMessageLimitCreditModal] =
    useState({
      message: '',
      status: '',
    })

  const [isErrorCompanyOrWarehouse, setIsErrorCompanyOrWarehouse] =
    useState(false)

  useEffect(() => {
    setPromisedDate(deliveryDateState)
  }, [deliveryDateState])

  const [isPickupInLockers, setIsPickupInLockers] = useState(false)
  const [lockerSelected, setLockerSelected] = useState(null)
  const [slotSelected, setSlotSelected] = useState(null)
  const [showLocker, setShowLocker] = useState(false)

  const [snackbarMessage, setSnackbarMessage] = useState({
    open: false,
    message: '',
    severity: '',
  })

  const useSelectorQuoteObject = useSelector(state => state?.cotizacion)

  const isCountedCustomer = validatorIsCountedCustomer(
    useSelectorQuoteObject?.QuoteHeader
  )

  const handleClose = () =>
    setSnackbarMessage({
      open: false,
      message: '',
      severity: '',
    })

  const useSelectorProducts = useSelector(state => state.cotizacion.QuoteHeader)

  const customerSavedLocations = useSelector(
    state => state.sellOrder.customerInfoObject,
    shallowEqual
  )

  const deliveryMethod = useValidatePermission(VAPermissions.deliveryMethod)
  const { loadingSupplierProducts, supplierProduct } = useSelector(
    state => state.catalog
  )

  const user = useSelector(state => state.login.user)
  const [dispatchTypeSelected, setDispatchTypeSelected] = useState(
    '' + dispatchTypeId.domicilio
  )
  const { sellOrderObject, sellOrderPostData, isCommercialCreditSelected } =
    useSelector(state => state.sellOrder)
  const isWebDocument =
    sellOrderPostData?.Data?.SalesDocumentInfo?.Origin === 'AB'

  const isBranchPickup = deliveryMethodState === 'BRANCH'
  const customerId = useSelectorProducts?.CustomerId
  const isRegisteredCustomer = validatorIsCountedCustomer(useSelectorProducts)

  const canPickupInLockers =
    isWebDocument && isBranchPickup && isRegisteredCustomer

  const [sendingSubmit, setSendingSubmit] = useState(false)
  const [isInitialLoad, setIsInitialLoad] = useState(true)

  useEffect(() => {
    if (open) {
      setIsInitialLoad(true)

      if (!location) {
        const savedAddressId =
          sellOrderObject?.QuoteAddressId ||
          sellOrderPostData?.Data?.SalesDocumentInfo?.Address_AddressId

        if (savedAddressId) {
          const addressList =
            customerSavedLocations?.AdministrativeStoreInfo?.AddressList ||
            customerSavedLocations?.AddressList

          if (addressList?.length) {
            const existingAddress = addressList.find(
              address =>
                address?.AddressInfo?.AddressId === savedAddressId ||
                address?.AddressInfo?.Address_AddressId === savedAddressId
            )

            if (existingAddress) {
              setLocation(existingAddress)
            }
          }
        }
      }
    }
  }, [
    open,
    location,
    customerSavedLocations,
    sellOrderObject,
    sellOrderPostData,
  ])

  const theme = createTheme({
    typography: {
      fontSize: 20,
    },
    components: {
      MuiIconButton: {
        styleOverrides: {
          sizeMedium: {
            color: '#003082',
          },
        },
      },
    },
  })

  useEffect(() => {
    const productIds = data
      .filter(p => p.solicitud_despacho > 0)
      .map(p => p.productId)

    if (isDirectDelivery) dispatch(supplierAction({ ProductIds: productIds }))
  }, [isDirectDelivery])

  const closeBar = () => {
    handleOpen(false)
    setIsDirectDelivery(false)
    setDeliveryTypeState(null)
    setLocation(null)
  }

  const onKeyDown = e => {
    e.preventDefault()
  }

  const changeMethod = useCallback(type => {
    setDeliveryMethodState(type)
    setDeliveryTypeState('')
    setSeeMoreState(false)
    setSucState('')
    setLocation(null)
    setIsDirectDelivery(false)
  }, [])

  // Get fulFlimentPlans by IdDelivery
  const onChangeDeliveryMethod = dispatchTypeSelectedP => {
    const payload = {
      TypeDispatchId: dispatchTypeSelectedP,
      SalesOrderTypeId:
        isCommercialCreditSelected?.credit === 'yes'
          ? salesOrderTypeIds.credito_comercial
          : salesOrderTypeIds.pago_contado,
      PageNumber: 1,
      PageSize: 100,
    }
    dispatch(fullfilmentPlanActionByDelivery(payload))
  }

  const fetchBranchDetails = async () => {
    const responseBranch = await dispatch(
      searchInfoBranchId(sucState.BranchOfficeId)
    )

    if (responseBranch?.length) {
      const branchSelected = responseBranch[0]

      setSucState(prev => ({
        ...prev,
        HasLocker: Boolean(branchSelected.HasLocker),
      }))
    }
  }

  useEffect(() => {
    if (isWebDocument && webOdvDetails && open) {
      const isHomeDelivery = webOdvDetails?.DeliveryType === 1
      isHomeDelivery ? handleHomeDeliveryMethod() : handleStoreDeliveryMethod()
      const defaultSucState = branchesData.find(
        suc =>
          suc.WarehouseId?.toLowerCase() ===
          webOdvDetails.WeareHouseId?.toLowerCase()
      )
      defaultSucState?.WarehouseId && setSucState(defaultSucState)

      const date = dayjs(
        webOdvDetails?.DeliveryDate || webOdvDetails.PromisedDate
      )
      webOdvDetails?.DeliveryDate && setDeliveryDateState(date)

      const defaultAddress = customerSavedLocations?.AddressList?.find(
        address =>
          address.AddressInfo?.AddressId?.toLowerCase() ===
          webOdvDetails?.AddressId?.toLowerCase()
      )

      defaultAddress && isHomeDelivery && setLocation(defaultAddress)
      defaultAddress && isHomeDelivery && setSeeMoreState(true)
    }
  }, [
    isWebDocument,
    branchesData,
    webOdvDetails,
    customerSavedLocations?.AddressList,
    open,
  ])

  useEffect(() => {
    const selectedFulfillmentPlanId = (fullfilmentResponse?.Data || []).find(
      f =>
        f.FulfillmentPlanId?.toLowerCase() ===
        fulfillmentPlanIdSelected?.toLowerCase()
    )

    if (selectedFulfillmentPlanId && open) {
      setDeliveryTypeState(selectedFulfillmentPlanId)
    }
  }, [open, fullfilmentResponse, fulfillmentPlanIdSelected])

  // Auto-select "Entrega Directa Proveedor" when isDirectDelivery is true
  useEffect(() => {
    if (isDirectDelivery && fullfilmentResponse?.Data?.length > 0) {
      const directDeliveryOption = fullfilmentResponse.Data.find(
        f => f.FulfillmentPlanId === directDelivertSupplier
      )
      if (directDeliveryOption) {
        setDeliveryTypeState(directDeliveryOption)
      }
    }
  }, [isDirectDelivery, fullfilmentResponse])

  useEffect(() => {
    if (deliveryMethodODV) {
      deliveryMethodODV === 'DEL'
        ? handleHomeDeliveryMethod(deliveryMethodODV)
        : handleStoreDeliveryMethod(deliveryMethodODV)
    }
  }, [deliveryMethodODV])

  useEffect(() => {
    if (deliveryDateState && deliveryDateState.isBefore(dayjs())) {
      setPromisedDate(deliveryDateState)
    }
  }, [deliveryDateState])

  useEffect(() => {
    if (sucState?.BranchOfficeId && open) {
      fetchBranchDetails()
    } else {
      setShowLocker(false)
    }
  }, [open, sucState?.BranchOfficeId])

  useEffect(() => {
    const isPendingDeliveryfullfilmentID =
      ID_CONSTANTS.fullFilmentData.pendingDeliveryID ===
      deliveryTypeState?.FulfillmentPlanId

    const hasLocker = sucState?.HasLocker === true

    if (canPickupInLockers) {
      setShowLocker(hasLocker && isPendingDeliveryfullfilmentID)
    }
  }, [
    sucState?.HasLocker,
    deliveryTypeState?.FulfillmentPlanId,
    canPickupInLockers,
  ])

  const handleHomeDeliveryMethod = useCallback(() => {
    changeMethod('DEL')
    setOpenDropdown({
      ...openDropdown,
      selectBranchOffice: false,
      selectSupplier: false,
      dispatchTypeDomicile: false,
      dispatchTypeBranchOffice: false,
    })
    setSucState(null)
    setDispatchTypeSelected(dispatchTypeId.domicilio)
    onChangeDeliveryMethod(dispatchTypeId.domicilio)
  }, [changeMethod, onChangeDeliveryMethod])

  const handleStoreDeliveryMethod = () => {
    changeMethod('BRANCH')
    setOpenDropdown({
      ...openDropdown,
      selectBranchOffice: false,
      selectSupplier: false,
      dispatchTypeDomicile: false,
      dispatchTypeBranchOffice: false,
    })
    setSucState(null)
    setDispatchTypeSelected(dispatchTypeId.retiroTienda)
    onChangeDeliveryMethod(dispatchTypeId.retiroTienda)
  }

  const renderDeliveryMethodButtons = () => {
    return (
      <Row>
        <h2
          className="delivery-type-title"
          data-testid="container-delivery-method-title">
          {t('RIGHT_SELECTION_MODAL.SELECT_DELIVERY_METHOD_TITLE')}
        </h2>
        <Col>
          <Row className="delivery-button-container">
            <button
              className={
                deliveryMethodState === 'DEL'
                  ? 'delivery-button-style-active'
                  : 'delivery-button-style-inactive'
              }
              onClick={handleHomeDeliveryMethod}
              data-testid="btn-select-home-delivery">
              <IconCarrito
                className={
                  deliveryMethodState === 'DEL'
                    ? 'delivery-method-img'
                    : 'delivery-method-img-inactive'
                }
              />
              <span
                className={
                  deliveryMethodState === 'DEL'
                    ? 'delivery-method-text'
                    : 'delivery-method-text-inactive'
                }>
                {t('RIGHT_SELECTION_MODAL.HOUSE_OPTION')}
              </span>
            </button>
            <button
              className={
                deliveryMethodState === 'BRANCH'
                  ? 'delivery-button-style-active'
                  : 'delivery-button-style-inactive'
              }
              onClick={handleStoreDeliveryMethod}
              data-testid="btn-select-branch-delivery">
              <ShopCarrito
                className={
                  deliveryMethodState === 'BRANCH'
                    ? 'delivery-method-img'
                    : 'delivery-method-img-inactive'
                }
              />
              <span
                className={
                  deliveryMethodState === 'BRANCH'
                    ? 'delivery-method-text'
                    : 'delivery-method-text-inactive'
                }>
                {t('RIGHT_SELECTION_MODAL.BRANCH_OPTION')}
              </span>
            </button>
          </Row>
        </Col>
      </Row>
    )
  }

  const [minDateOA, setMinDateOA] = useState(null)
  const [oaSuggestedBranch, setOaSuggestedBranch] = useState(null)

  const productsForOA = useMemo(
    () =>
      dispatchQtyState.map(p => ({ Sku: p.referencia, Quantity: p.cantidad })),
    [dispatchQtyState]
  )

  const {
    oaLoading,
    oaError,
    executeOADelivery,
    getMinDateFromOA,
    getSuggestedBranchFromOA,
  } = useOrderAllocation({
    documentId:
      sellOrderObject?.QuoteHeaderId || sellOrderObject?.salesOrderHeaderId,
    companyCode: sellOrderObject?.CompanyCode,
    products: productsForOA,
  })

  useEffect(() => {
    const runOA = async () => {
      if (
        deliveryMethodState === 'DEL' &&
        location &&
        sellOrderObject?.CompanyCode &&
        productsForOA.length &&
        !oaLoading
      ) {
        const oaResponse = await executeOADelivery(location)
        if (oaResponse) {
          const branch = getSuggestedBranchFromOA(oaResponse)
          if (branch && (!isInitialLoad || !sucState)) {
            setOaSuggestedBranch(branch)
          }

          const minDate = getMinDateFromOA(oaResponse)
          if (minDate) {
            setMinDateOA(minDate)
            const shouldUpdateDate = isInitialLoad
              ? !deliveryDateState ||
                dayjs(deliveryDateState).isBefore(dayjs(minDate))
              : true

            if (shouldUpdateDate) {
              setDeliveryDateState(dayjs(minDate))
              setPromisedDate(dayjs(minDate).toISOString())
            }
          }
        }
      }
    }
    runOA()
  }, [
    location,
    deliveryMethodState,
    open,
    sellOrderObject?.CompanyCode,
    productsForOA.length,
  ])

  useEffect(() => {
    if (location && !isInitialLoad) {
      setIsInitialLoad(false)
    }
  }, [location])

  useEffect(() => {
    if (oaSuggestedBranch && !sucState) {
      const realBranch = branchesData?.find(
        branch =>
          branch.Code === oaSuggestedBranch.branchId ||
          branch.WarehouseId === oaSuggestedBranch.branchId ||
          branch.Code === oaSuggestedBranch.WarehouseId
      )

      if (realBranch) {
        const suggestedSuc = {
          ...oaSuggestedBranch,
          Description:
            realBranch.Description ||
            oaSuggestedBranch?.branchName ||
            oaSuggestedBranch?.Description,
          CompanyId: realBranch.CompanyId,
          WarehouseId: realBranch.WarehouseId, // ✅ Usar el WarehouseId real (GUID)
          AddressId:
            realBranch.AddressId ||
            oaSuggestedBranch?.addressId ||
            oaSuggestedBranch?.AddressId,
          BranchOfficeId: realBranch.BranchOfficeId || realBranch.WarehouseId, // ✅ Usar BranchOfficeId real
          Code: realBranch.Code,
          WarehouseCode: realBranch.WarehouseCode,
          WarehouseName: realBranch.WarehouseName,
          WarehouseAddress: realBranch.WarehouseAddress,
        }
        setSucState(suggestedSuc)
      } else {
        const suggestedSuc = {
          ...oaSuggestedBranch,
          Description:
            oaSuggestedBranch?.branchName || oaSuggestedBranch?.Description,
          WarehouseId:
            oaSuggestedBranch?.branchId || oaSuggestedBranch?.WarehouseId,
          AddressId:
            oaSuggestedBranch?.addressId || oaSuggestedBranch?.AddressId,
          BranchOfficeId:
            oaSuggestedBranch?.branchId || oaSuggestedBranch?.BranchOfficeId,
        }
        setSucState(suggestedSuc)
      }
    }
  }, [oaSuggestedBranch, sucState, branchesData])

  const isAddressDisabled = oaLoading && deliveryMethodState === 'DEL'

  useEffect(() => {
    changeMethod(deliveryMethodODV)
    const addressList =
      customerSavedLocations?.AdministrativeStoreInfo?.AddressList

    if (open && !addressList?.length && !isCountedCustomer) {
      const loadCustomerAddresses = async () => {
        try {
          const customerData = await dispatch(getCustomerById(customerId))
          if (customerData) {
            dispatch({ type: 'SET_CUSTOMER_INFO', payload: customerData })
          }
        } catch (error) {
          console.error('Error loading customer addresses:', error)
        }
      }
      loadCustomerAddresses()
    }
  }, [])

  // Handler para selección manual de dirección
  const handleSelectLocation = address => {
    setIsInitialLoad(false)
    setLocation(address)
  }

  const renderLocation = addresses => {
    const rawList =
      customerSavedLocations?.AdministrativeStoreInfo?.AddressList ??
      customerSavedLocations?.AddressList

    const withAddressInfo = (rawList ?? []).filter(item => item?.AddressInfo)

    const addressList = withAddressInfo
      ? withAddressInfo.filter(
          (item, idx, arr) =>
            idx ===
            arr.findIndex(
              x => x.AddressInfo.AddressId === item.AddressInfo?.AddressId
            )
        )
      : []

    const newAddress = (addressList || []).filter(
      address => address?.AddressInfo
    )
    const sliceAddress = seeMoreState ? newAddress : newAddress.slice(0, 6)
    return (
      <Row>
        <h2
          className="delivery-location-title"
          data-testid="container-address-selection-title">
          {t('RIGHT_SELECTION_MODAL.SELECT_DIRECTION')}
        </h2>
        <Col>
          <Row
            className="direction-button-container"
            data-testid="container-address-list">
            {sliceAddress?.map((address, index) => (
              <AddressOption
                key={index}
                item={address}
                setLocation={
                  isAddressDisabled ? () => {} : handleSelectLocation
                }
                location={location}
                clienteAddresses={[sliceAddress]}
                showAddressDetail={details => {
                  showEditAddress(details)
                }}
                disabled={isAddressDisabled}
              />
            ))}
          </Row>
          {newAddress.length > 6 && (
            <Row>
              <div className="see-more-address">
                <p
                  onClick={() => setSeeMoreState(!seeMoreState)}
                  data-testid="btn-toggle-address-list">
                  {seeMoreState
                    ? t('RIGHT_SELECTION_MODAL.SEE_LESS')
                    : t('RIGHT_SELECTION_MODAL.SEE_MORE')}
                </p>
              </div>
            </Row>
          )}
        </Col>
      </Row>
    )
  }

  const renderAddMoreLocation = () => {
    return (
      <Row
        onClick={() => {
          deployAddAddres(true)
        }}
        className="add-direction-container"
        data-testid="btn-add-new-address">
        <Col className="add-direction-label-col">
          <label className="add-direction-label-text" htmlFor="">
            {t('RIGHT_SELECTION_MODAL.ADD_NEW_DIRECTION')}
          </label>
        </Col>
        <Col className="add-direction-plus-sign-col">
          <div className="add-direction-plus">+</div>
        </Col>
      </Row>
    )
  }

  const DynamicSelector = ({
    title,
    setShowState,
    showState,
    valueState,
    placeholder,
    mappedInfo,
    controlValue,
    setValueState,
    loading,
    showSearch,
  }) => {
    const [textValue, setTextValue] = useState('')
    const [data, setData] = useState(mappedInfo)
    const debounce = useDebounce()
    const handlerSearch = value => {
      const result = mappedInfo.filter(item =>
        item?.Description?.toUpperCase()?.includes(value.toUpperCase())
      )
      setData(result)
    }

    const hasSelectedValue =
      valueState &&
      (valueState.descriptionFulfillmentPlan ||
        valueState.Description ||
        valueState.ProviderName)

    useEffect(() => {
      setData(mappedInfo)
    }, [mappedInfo])

    return (
      <ClickAwayListener
        onClickAway={event => {
          if (
            showState &&
            !event.target?.id !== 'generic-address-filter-content'
          ) {
            setShowState(false)
          }
          if (
            showDeliveryTypeState &&
            event.target?.id !== 'generic-address-filter-content'
          )
            setShowDeliveryTipeState(false)

          if (
            showSucState &&
            event.target?.id !== 'generic-address-filter-content'
          )
            setShowSucState(false)
        }}>
        <div>
          <Row className="no-margin-nopadding generic-address-father-container">
            <div className="generic-address-title-text">{t(title)}</div>
            <div className="no-margin-nopadding generic-address-search-filter">
              <button
                disabled={loading}
                id="generic-address-filter-content"
                className="generic-address-filter-content"
                onClick={() => setShowState(!showState)}
                data-testid={`btn-dropdown-${controlValue.toLowerCase()}`}>
                <h2
                  onClick={() => setShowState(!showState)}
                  className={
                    hasSelectedValue
                      ? 'generic-address-label-text'
                      : 'generic-address-label-placeholder'
                  }>
                  {hasSelectedValue && mappedInfo
                    ? valueState.descriptionFulfillmentPlan ||
                      valueState.Description ||
                      valueState.ProviderName
                    : !hasSelectedValue && mappedInfo?.length
                    ? t(placeholder)
                    : 'Sin datos'}
                </h2>
                {loading ? (
                  <FontAwesomeIcon icon={faSpinner} className="spinner" />
                ) : (
                  <FontAwesomeIcon
                    onClick={() => setShowState(!showState)}
                    icon={faChevronDown}
                    className="generic-address-down-icon"
                  />
                )}
              </button>
              <ul
                className={
                  showState
                    ? 'generic-address-filter-options'
                    : 'generic-address-filter-options-hidden'
                }
                data-testid={`container-dropdown-options-${controlValue.toLowerCase()}`}>
                {showSearch && (
                  <li className="item-search-box-list-price">
                    <div className="item-list-price-li-search">
                      <input
                        onChange={e => {
                          setTextValue(e.target.value)
                          debounce(() => handlerSearch(e.target.value), 500)
                        }}
                        value={textValue}
                        type="text"
                        id="generic-address-filter-content"
                        className="list-price-search"
                        placeholder="Buscar"
                        data-testid={`input-search-${controlValue.toLowerCase()}`}
                      />
                      <img
                        src={search}
                        className="list-price-search-icon"
                        alt="search"
                        id="generic-address-filter-content"
                        onClick={() => handlerSearch(textValue)}
                      />
                    </div>
                  </li>
                )}
                {data?.map((item, index) => {
                  if (
                    item?.FulfillmentPlanId?.toLowerCase() ===
                    defaultSupplier?.fulfillmentPlanId?.toLowerCase()
                  )
                    return null

                  return (
                    <li
                      className="generic-address-filter-option"
                      key={controlValue + index}
                      data-testid={`container-option-${controlValue.toLowerCase()}-${index}`}>
                      <input
                        type="radio"
                        className="radio"
                        id={controlValue + index.toString()}
                        name="distrito"
                        value={
                          item.descriptionFulfillmentPlan ||
                          item.Description ||
                          item.ProviderName
                        }
                        onClick={values => {
                          setValueState(item)
                          setShowState(false)
                        }}
                        data-testid={`input-radio-${controlValue.toLowerCase()}-${index}`}
                      />
                      <label
                        htmlFor={controlValue + index.toString()}
                        className={styles.label}>
                        {item.descriptionFulfillmentPlan ||
                          item.Description ||
                          item.ProviderName}
                      </label>
                    </li>
                  )
                  // }
                })}
              </ul>
            </div>
          </Row>
        </div>
      </ClickAwayListener>
    )
  }

  useEffect(() => {
    const dataODV = sellOrderPostData?.Data?.SalesDocumentInfo
    const phoneNumber = useSelectorQuoteObject?.QuoteHeader?.Telephone_Number

    if (dataODV?.Origin === 'AB') {
      setFormDataMerchandise({
        retirement:
          dataODV?.FullNameWithdrawWeb === 'Cliente'
            ? 'isCustomer'
            : 'isAnotherPerson',
        fullName: dataODV?.FullNameWithdrawWeb,
        phone: {
          Prefix: DEFAULT_PHONE_PREFIX,
          number: dataODV?.PhoneNumberWithdrawWeb,
        },
        comment: comments || dataODV?.AdditionalNoteWeb,
      })
    } else if (isCountedCustomer && phoneNumber) {
      setFormDataMerchandise(prev => ({
        ...prev,
        phone: {
          Prefix: DEFAULT_PHONE_PREFIX,
          number: phoneNumber,
        },
      }))
    }
  }, [sellOrderPostData, comments])

  const renderGenericMultipleSelectForm = useCallback(
    ({
      title,
      showState,
      setShowState,
      valueState,
      setValueState,
      mappedInfo,
      placeholder,
      controlValue,
      blockComboBox,
      preselectedValue,
      showSearch,
    }) => {
      return (
        <DynamicSelector
          title={title}
          setShowState={setShowState}
          showState={showState}
          valueState={valueState}
          placeholder={placeholder}
          mappedInfo={mappedInfo}
          controlValue={controlValue}
          setValueState={setValueState}
          showSearch={showSearch}
        />
      )
    },
    []
  )

  const validateLockerField = () => {
    if (!canPickupInLockers) return true
    if (!showLocker) return true
    if (!isPickupInLockers) return true
    return Boolean(slotSelected && lockerSelected)
  }

  const validateForms = () => {
    // Validación de promisedDate menor a hoy
    if (promisedDate) {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const selected = new Date(promisedDate)
      selected.setHours(0, 0, 0, 0)
      if (selected < today) {
        return false
      }
    }
    const validateDeliveryTypeState = deliveryTypeState?.FulfillmentPlanId
    const isValidNewcost = () =>
      !listOfNewCosts.some(line => line.newCost === 0 || line.newCost === '')

    const isValidLocker = validateLockerField()

    // si es cliente contado se valida el teléfono de retiro
    const rawPhone =
      formDataMerchandise.phone?.number?.number ??
      formDataMerchandise.phone?.number

    const hasValidPhone = rawPhone?.toString().length >= 7

    const validationDeliveryLocker =
      isDirectDelivery &&
      validateDeliveryTypeState &&
      isValidNewcost() &&
      isValidLocker &&
      sucState &&
      deliveryDateState &&
      location &&
      supplier &&
      (!isCountedCustomer || hasValidPhone)

    const validationBranchyLocker =
      !isDirectDelivery &&
      deliveryMethodState === 'BRANCH' &&
      validateDeliveryTypeState &&
      Object.prototype.hasOwnProperty.call(
        deliveryTypeState,
        'FulfillmentPlanId'
      ) &&
      ((sucState && deliveryDateState) || (location && deliveryDateState)) &&
      (!isCountedCustomer || hasValidPhone)

    const validationDelivery =
      !isDirectDelivery &&
      deliveryMethodState === 'DEL' &&
      validateDeliveryTypeState &&
      sucState &&
      deliveryDateState &&
      location &&
      (!isCountedCustomer || hasValidPhone)

    if (validationDeliveryLocker) {
      return true
    } else {
      if (validationBranchyLocker) {
        return isValidLocker
      }

      if (validationDelivery) {
        return true
      }

      return false
    }
  }

  const isButtonDisabled = oaLoading || !validateForms()

  const populateItemsArrayOfPayload = () => {
    const arrayOfItems = []

    sellOrderObject?.Lines.forEach(lineItem => {
      const quantityDispatch =
        typeof lineItem?.sellOrderTableValues?.solicitud_despacho === 'string'
          ? Number(
              lineItem.sellOrderTableValues.solicitud_despacho.replace(/,/g, '')
            )
          : lineItem?.sellOrderTableValues?.solicitud_despacho

      const amountPicked =
        quantityDispatch * lineItem?.sellOrderTableValues?.precio_unitario || 0
      const taxes = sellOrderObject.TaxExempt
        ? 0
        : amountPicked * lineItem?.TaxCategoryValue
      const amountWithTaxPicked = amountPicked + taxes
      const qtyDelivered =
        quantityDispatch + lineItem?.sellOrderTableValues?.qtyDelivered || 0
      const qtyCanceled = lineItem?.sellOrderTableValues?.qtyCanceled || 0

      const newPending = Formatter.Money(
        parseFloat(lineItem?.sellOrderTableValues?.cantidad || 0) -
          (parseFloat(qtyDelivered) + parseFloat(qtyCanceled)),
        {
          withFormat: false,
        }
      )
      const qtyPending = Number(newPending)

      const newProductCost = listOfNewCosts?.find(
        p => p?.productId === lineItem?.ProductId
      )?.newCost
      const cost = parseFloat(newProductCost).toFixed(2)
      const payloadFormation = {
        dispatchRequestLineDetailId: '00000000-0000-0000-0000-000000000000',
        salesOrderHeaderId: sellOrderObject?.salesOrderHeaderId,
        productId: lineItem?.ProductId,
        priceListId: lineItem?.PriceListId,
        warehouseId: sucState?.WarehouseId,
        quantity: quantityDispatch,
        amount: Number(
          Formatter.Money(amountPicked, {
            withFormat: false,
            decimalPrecision: 2,
            rounded: true,
          })
        ),
        amountWithTax: Number(
          Formatter.Money(amountWithTaxPicked, {
            withFormat: false,
            decimalPrecision: 2,
            rounded: true,
          })
        ),
        DiscountAmount: lineItem?.DiscountAmount,
        tax: taxes,
        cost: isDirectDelivery ? Number(cost) : lineItem?.Cost,
        price: lineItem?.Price,
        discount: lineItem?.Discount,
        lineNum: lineItem?.LineNum,
        productSerialNumber: 0,
        createdBy: null,
        lastModifiedBy: null,
        status: 1,
        FulfillmentPlanId: deliveryTypeState.FulfillmentPlanId,
        UoMId: lineItem?.UoMId
          ? lineItem.UoMId
          : '6360326E-23B2-40F0-9F7B-0056EBA3A1CB',
        NegotiatedReasonId: sellOrderObject?.NegotiatedReasonId,
        WarrantyProductId: lineItem?.WarrantyProductId,
        qtyOrdered: lineItem?.sellOrderTableValues?.cantidad,
        qtyDelivered,
        qtyPending,
      }

      const cleanEntries = Object.fromEntries(
        Object.entries(payloadFormation).filter(([_, v]) => v != null)
      )
      arrayOfItems.push(cleanEntries)
    })
    const cleanProducts = removeDuplicateProducts(arrayOfItems)
    return cleanProducts
  }

  const notifyDispatchCreation = async ({ documentHeaderId }) => {
    try {
      await postNotifyDispatch({ documentHeaderId })
    } catch (e) {
      console.error('Error notifying dispatch creation', e)
    }
  }

  const messageCreditError = ({ account, status }) => {
    const message = t('MESSAGE_ERROR_COMERCIAL_CREDIT', {
      status,
      account,
    })

    return message
  }

  const callCreditAccountValidations = async (createSaleOrderPayload, e) => {
    let totalAmount = 0
    let totalAmountExent = 0
    // eslint-disable-next-line array-callback-return
    sellOrderObject.Lines.map(line => {
      const quantityDispatch =
        typeof line.sellOrderTableValues.solicitud_despacho === 'string'
          ? Number(
              line.sellOrderTableValues.solicitud_despacho.replace(/,/g, '')
            )
          : line.sellOrderTableValues.solicitud_despacho

      totalAmount +=
        quantityDispatch * line.sellOrderTableValues.precio_unitario
      totalAmountExent +=
        quantityDispatch * line.sellOrderTableValues.precio_unitario
      // Add the taxes
      totalAmount +=
        quantityDispatch *
        line.sellOrderTableValues.precio_unitario *
        line.TaxCategoryValue
    })
    const companyCode =
      companiesCodeOracle[sellOrderObject?.CompanyId.toUpperCase()] || '01'

    const commercialCreditPayloadConsult = {
      product: 'oracle-credit-commercial-customer',
      no_cia: companyCode,
      no_cliente:
        sellOrderPostData?.Data?.SalesDocumentInfo?.CreditAccountNumber,
    }

    const response = await dispatch(
      validateAmountOnCommercialCredit(commercialCreditPayloadConsult)
    )

    if (!response.message) {
      const isExent = response.exento.toUpperCase() === 'S'
      const balance = response.limite - response.saldo
      const totalValidate = isExent ? totalAmountExent : totalAmount
      // if is exent change tax, total, and data form lines
      if (isExent) {
        createSaleOrderPayload.dispatchRequest.tax = 0
        createSaleOrderPayload.dispatchRequest.total =
          createSaleOrderPayload.dispatchRequest.subTotal
        // change amount and taxes by lines
        createSaleOrderPayload.dispatchRequest.amount = totalValidate
        // eslint-disable-next-line array-callback-return
        createSaleOrderPayload.dispatchRequest.lines.map(lineNumber => {
          lineNumber.tax = 0
          lineNumber.amountWithTax = lineNumber.amount
        })
        createSaleOrderPayload.dispatchRequest.TaxExempt = true
      }
      if (balance >= totalValidate) {
        const result = await dispatch(
          generateDispatchOrderAction(createSaleOrderPayload)
        )

        const sdDocHeaderId = result.Data?.SalesDocumentInfo?.DocHeaderId

        if (!sdDocHeaderId) {
          enableButtonOnclick(e)
          setIsErrorDispatchModal(true)
          setMessageDispatchModal({
            message: result?.Status?.Message,
            status: 'error',
          })
          return
        }
        if (isWebDocument) {
          await notifyDispatchCreation({ documentHeaderId: sdDocHeaderId })
        }

        if (result.message !== 'ERROR') {
          setDispatchValues()
          history.push(
            `${ROUTES.orderDispatch}${result.Data?.SalesDocumentInfo?.DocHeaderId}`
          )
        }
      } else {
        setIsErrorLimitCreditModal(true)
        setIsErrorMessageLimitCreditModal({
          message: 'GENERIC_MODAL.ERROR_COMMERCIAL_CREDIT',
          status: 'error',
        })
        enableButtonOnclick(e)
      }
    } else {
      setIsErrorComercialCreditModal(true)
      setIsErrorMessageComercialCreditModal({
        message: messageCreditError({
          status: response.message,
          account: response.account,
        }),
        status: 'error',
      })
      enableButtonOnclick(e)
    }
  }

  const callRegularFlow = async (createSaleOrderPayload, e) => {
    const result = await dispatch(
      generateDispatchOrderAction(createSaleOrderPayload)
    )
    const sdDocHeaderId = result.Data?.SalesDocumentInfo?.DocHeaderId

    if (!sdDocHeaderId) {
      enableButtonOnclick(e)
      setIsErrorDispatchModal(true)
      setMessageDispatchModal({
        message: result?.Status?.Message,
        status: 'error',
      })
      return
    }

    if (isWebDocument) {
      await notifyDispatchCreation({ documentHeaderId: sdDocHeaderId })
    }

    if (result.message !== 'ERROR') {
      localStorage.setItem(
        'createDispatch',
        JSON.stringify({
          documentNumber:
            sellOrderPostData?.Data?.SalesDocumentInfo?.DocumentNumber,
          timestamp: Date.now(),
        })
      )

      setTimeout(() => {
        localStorage.removeItem('createDispatch')
      }, 100)
      setDispatchValues()
      const idDespacho = `${ROUTES.orderDispatch}${result.Data?.SalesDocumentInfo.DocHeaderId}`
      history.push(idDespacho)
    }
  }

  const reserveLockerSlotWithRetry = async (slotId, slotData) => {
    const maxTotalAttempts = 3
    let attemptCount = 0

    while (attemptCount < maxTotalAttempts) {
      try {
        attemptCount++
        const response = await updateSlotService(slotId, slotData)
        return response
      } catch (error) {
        console.error(
          `Error en updateSlotService (intento ${attemptCount}):`,
          error
        )

        if (attemptCount >= maxTotalAttempts) {
          console.error('Se agotaron todos los intentos')
          throw error
        }

        const delay = Math.pow(2, attemptCount - 1) * 500
        await new Promise(resolve => setTimeout(resolve, delay))
      }
    }
  }

  const generateDispatchDocument = async e => {
    const isPendingDeliveryfullfilmentID =
      ID_CONSTANTS.fullFilmentData.pendingDeliveryID ===
      deliveryTypeState.FulfillmentPlanId

    if (
      canPickupInLockers &&
      isPendingDeliveryfullfilmentID &&
      slotSelected?.id
    ) {
      try {
        const slotData = {
          customerName: useSelectorProducts?.CustomerNameDocument,
          customerDocument: useSelectorProducts?.CustomerNumberId,
          customerEmail:
            useSelectorProducts?.CustomerEmail ||
            useSelectorProducts.EmailAddress,
          customerCellphone:
            useSelectorProducts.Cellphone_Number ||
            useSelectorProducts?.Telephone_Number,
          orderNumber:
            sellOrderPostData?.Data?.SalesDocumentInfo?.DocumentNumber,
          description: `Orden de venta: ${sellOrderPostData?.Data?.SalesDocumentInfo?.DocumentNumber}`,
        }

        const responseSlot = await reserveLockerSlotWithRetry(
          slotSelected.id,
          slotData
        )

        const messageSuccess = `Retiro confirmado en el \nlocker de ${lockerSelected.name}.\nSolicitud ID: ${responseSlot.id}`
        setSnackbarMessage({
          open: true,
          message: messageSuccess,
          severity: 'success',
        })
      } catch (error) {
        setSnackbarMessage({
          open: true,
          message: 'No se pudo completar el retiro en locker.',
          severity: 'error',
        })
      }
    }

    const linesPicked = populateItemsArrayOfPayload()
    let subTotalDispatch = 0
    let totalTaxDispatch = 0
    // eslint-disable-next-line array-callback-return
    linesPicked.map(line => {
      subTotalDispatch += line.amount
      if (line?.taxesExempt) {
        totalTaxDispatch = 0
      } else {
        totalTaxDispatch += line.tax
      }
    })

    const totalDispatch = subTotalDispatch + totalTaxDispatch
    let createSaleOrderPayload = {
      documentTypeId: ID_CONSTANTS.dispatchOrder.dipatchTypeID,
      dispatchRequest: {
        ...(supplier ? { ProviderId: supplier.ProviderId } : {}),
        dispatchRequestHeaderId: null,
        salesOrderHeaderId:
          sellOrderPostData?.Data?.SalesDocumentInfo?.DocHeaderId, // "94ECBC98-1235-4537-AF11-9851EE2E9C52",
        HeaderStatusId: ID_CONSTANTS.dispatchOrder.headerStatusDispatchOrderID,
        dispatchTypeId: dispatchTypeSelected,
        addressId:
          deliveryMethodState === 'DEL'
            ? location.AddressInfo.AddressId ||
              location.AddressInfo?.Address_AddressId
            : sucState.AddressId,
        fulfillmentPlanId: deliveryTypeState.FulfillmentPlanId,
        deliveryDate: deliveryDateState
          .format('YYYY-MM-DDTHH:mm:ss[Z]')
          .toString(),
        total: isWebDocument
          ? sellOrderPostData?.Data?.SalesDocumentInfo?.AmountWithTax
          : totalDispatch,
        subTotal: subTotalDispatch, // 20,
        tax: totalTaxDispatch, // sellOrderObject?.Tax,
        salesAgentId: user?.AuthenticationInfo?.UserId,
        comments: sellOrderObject?.comment,
        createdBy: null,
        lastModifiedBy: null,
        status: 1,
        salesAgentEmail: null,
        companyId: sucState?.CompanyId,
        companyCode: sucState?.Code,
        CustomerEmail: sellOrderObject?.CustomerEmail,
        WarehouseId: sucState?.WarehouseId,
        DocumentDate: sellOrderObject?.DocumentDate,
        ExternalCode: null,
        origin: 'VA',
        customerId: sellOrderPostData?.Data?.SalesDocumentInfo?.CustomerId,
        lines: linesPicked,
        isDirectDelivery,
        TaxExempt: sellOrderObject?.TaxExempt,
        PromisedDate: promisedDate,
        BranchPickupContactId: sellOrderObject.BranchPickupContactId,
        fullName:
          formDataMerchandise.retirement === 'isCustomer'
            ? 'Cliente'
            : formDataMerchandise.fullName,
        phoneNumber:
          formDataMerchandise.phone?.number?.number ||
          formDataMerchandise.phone?.number ||
          '',
        additionalNote: formDataMerchandise.comment,
      },
    }

    const cleanEntries = Object.fromEntries(
      Object.entries(createSaleOrderPayload.dispatchRequest).filter(
        ([_, v]) => v != null
      )
    )

    createSaleOrderPayload = {
      ...createSaleOrderPayload,
      dispatchRequest: { ...cleanEntries },
    }

    if (deliveryMethodState === 'DEL') {
      const payload = {
        ...location,
        CustomerId: sellOrderObject?.CustomerId,
      }
      await checkSelectedLocation(payload)
    }

    if (
      sellOrderPostData?.Data?.SalesDocumentInfo?.CreditAccountId &&
      sellOrderPostData?.Data?.SalesDocumentInfo?.CreditAccountNumber
    ) {
      callCreditAccountValidations(createSaleOrderPayload, e)
    } else {
      callRegularFlow(createSaleOrderPayload, e)
    }
  }

  const setDispatchValues = () => {
    dispatch({
      type: 'SET_SELECTED_DATE',
      payload: deliveryDateState.toString(),
    })

    dispatch({
      type: 'SET_DELIVERY_TYPE',
      payload: deliveryTypeState,
    })

    if (deliveryMethodState === 'DEL') {
      dispatch({
        type: 'SET_SELECTED_ADDRESS',
        payload: location,
      })
    } else {
      dispatch({
        type: 'SET_SELECTED_ADDRESS',
        payload: sucState, // sucState,//{ AddressInfo: { AddressDetail: sucState } },
      })
    }
  }

  const renderVADDatePickerBox = (title, valueState, setValueState) => {
    return (
      <Row className="no-margin-nopadding generic-address-father-container">
        <div className="generic-address-title-text">{title}</div>
        <Col className="no-margin-nopadding">
          <ThemeProvider theme={theme}>
            <LocalizationProvider adapterLocale={es} dateAdapter={AdapterDayjs}>
              <DatePicker
                className="generic-date-picker-styles"
                inputFormat={t('RIGHT_SELECTION_MODAL.DATE_INPUT_FORMAT')}
                disableMaskedInput={true}
                minDate={minDateOA ? dayjs(minDateOA) : dayjs()}
                PopperProps={{ className: 'generic-date-picker-popper-styles' }}
                value={valueState}
                onChange={newValue => {
                  setValueState(newValue)
                  setPromisedDate(
                    newValue ? dayjs(newValue).toISOString() : null
                  )
                }}
                slotProps={{
                  textField: {
                    placeholder: t(
                      'RIGHT_SELECTION_MODAL.SET_DELIVERY_DATE_PLACEHOLDER'
                    ),
                    'data-testid': 'input-delivery-date',
                  },
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    sx={{ svg: { fontSize: 20 } }}
                    onKeyDown={onKeyDown}
                    error={false}
                    helperText={null}
                    inputProps={{
                      ...params.inputProps,
                      className: 'generic-date-input-styles',
                      placeholder: t(
                        'RIGHT_SELECTION_MODAL.SET_DELIVERY_DATE_PLACEHOLDER'
                      ),
                      'data-testid': 'input-delivery-date',
                    }}
                  />
                )}
                disabled={oaLoading && deliveryMethodState === 'DEL'}
              />
            </LocalizationProvider>
          </ThemeProvider>
        </Col>
      </Row>
    )
  }

  const renderOAError = () =>
    oaError ? (
      <Row>
        <Col>
          <div className="oa-error-message">
            <span style={{ color: 'red', fontWeight: 600 }}>{oaError}</span>
          </div>
        </Col>
      </Row>
    ) : null

  const validateDirectDelivery = () => {
    return (
      <div
        className="no-margin-nopadding generic-address-father-container"
        data-testid="container-direct-delivery">
        <div className="add-delivery-superior-margin">
          {deliveryMethod && (
            <div className="">
              <span className="generic-address-title-text">
                {t('TABLE_SELL_ORDER_T.CHECK_ON_DIRECT_TITLE')}
              </span>
              <label className="margin-label-sell-method">
                <input
                  type="radio"
                  name="directValidation"
                  checked={isDirectDelivery}
                  value="yes"
                  onChange={newValue => {
                    setIsDirectDelivery(!isDirectDelivery)
                    setDeliveryTypeState(null)
                    setSupplier(null)
                    setDeliveryMethodState('DEL')
                  }}
                  onClick={() => {
                    if (!isDirectDelivery) {
                      setDeliveryTypeState(null)
                      setSupplier(null)
                      setIsDirectDelivery(true)
                    }
                    setDeliveryTypeState(null)
                    onChangeDeliveryMethod(dispatchTypeId.domicilio)
                  }}
                  data-testid="input-radio-direct-delivery-yes"
                />
                <span className="table-sell-order-option-span">
                  {t('TABLE_SELL_ORDER_T.YES_SELECTED_OPTION')}
                </span>
              </label>
              <label className="margin-label-sell-method">
                <input
                  type="radio"
                  name="directValidation"
                  checked={!isDirectDelivery}
                  value="no"
                  onChange={newValue => {
                    setIsDirectDelivery(!isDirectDelivery)
                    setDeliveryTypeState(null)
                    setSupplier(null)
                    // setDeliveryMethodState("SUC");
                  }}
                  onClick={() => {
                    if (isDirectDelivery) {
                      setIsDirectDelivery(false)
                    }
                  }}
                  data-testid="input-radio-direct-delivery-no"
                />
                <span className="table-sell-order-option-span">
                  {t('TABLE_SELL_ORDER_T.NO_SELECTED_OPTION')}
                </span>
              </label>
            </div>
          )}
        </div>
        {isDirectDelivery ? (
          <div
            className="table-sell-order-directdel-row"
            data-testid="container-direct-delivery-warning">
            <div className="table-sell-order-directdel-column">
              <label className="table-sell-order-option-select-description">
                <span className="table-sell-order-option-select-description-important">
                  {t('TABLE_SELL_ORDER_T.IMPORTANT_LABEL')}
                </span>
                {t('TABLE_SELL_ORDER_T.IMPORTANT_WARNING')}
              </label>
            </div>
          </div>
        ) : null}
      </div>
    )
  }
  const onValidatePreOrderModals = () => {
    return (
      <SellOrderDeliveryWarning
        isNotValidDelivState={isNotValidDelivState}
        setIsNotValidDelivState={setIsNotValidDelivState}
        textTitle={t('SELL_ORDER_T.WARNING_TITLE_NO_DELIVERY')}
        textDescription={t('SELL_ORDER_T.WARNING_DESCRIPTION_NO_DELIVERY')}
        editQuote={t('SELL_ORDER_T.EDIT_QUOTE_LABEL')}
        returnToOrder={t('SELL_ORDER_T.RETURN_ORDER_LABEL')}
        onEditQuoteCallback={() => {
          history.goBack()
        }}
      />
    )
  }

  const validateDeliveryValues = useMemo(() => {
    return dispatchQtyState.some(item => item.isSupplierDirectDelivery)
  }, [dispatchQtyState])

  const checkPreorderValidations = e => {
    const defaultGuid = '00000000-0000-0000-0000-000000000000'

    if (
      !sucState ||
      !sucState?.WarehouseId ||
      !sucState?.CompanyId ||
      sucState?.WarehouseId === defaultGuid ||
      sucState?.CompanyId === defaultGuid
    ) {
      setIsErrorCompanyOrWarehouse(true)
      enableButtonOnclick(e)
      setSendingSubmit(false)
      return
    }

    setIsNotValidCostState(false)
    const isPassedDirectDeliveryValidations = validateDeliveryValues

    if (isDirectDelivery) {
      const productReferences = collectArrayOfReferences

      if (isPassedDirectDeliveryValidations) {
        generateDispatchDocument(e)
        return
      }
      if (productReferences.length) {
        enableButtonOnclick(e)
        setSendingSubmit(false)
        setIsNotValidDDProductState(true)
        setIsDirectDelivery(false)
        setDeliveryDateState(null)
        setDeliveryTypeState(null)
        setLocation(null)
      } else {
        generateDispatchDocument(e)
        return
      }
    }
    if (!isDirectDelivery) {
      generateDispatchDocument(e)
    } else {
      handleOpen(false)
      enableButtonOnclick(e)
      setSendingSubmit(false)
    }
  }

  const collectArrayOfReferences = useMemo(() => {
    return dispatchQtyState
      .filter(
        item =>
          item.isSelected &&
          item.solicitud_despacho > 0 &&
          !item.isSupplierDirectDelivery
      )
      .map(item => item.referencia)
  }, [dispatchQtyState])

  const onInvalidProductModal = () => {
    return (
      <CheckIsDDAvaliableModal
        isNotValidDDProductState={isNotValidDDProductState}
        setIsNotValidDDProductState={setIsNotValidDDProductState}
        setIsDirectDelivery={setIsDirectDelivery}
        mainTitleFirst={t('La referencia ')}
        mainTitleLast={t(' no tiene entrega directa')}
        onEditQuoteCallback={() => {
          history.goBack()
        }}
        referencesArray={collectArrayOfReferences}
      />
    )
  }

  const onCostsModal = () => {
    return (
      <CheckDeliveryCostsModal
        isNotValidCostState={isNotValidCostState}
        setIsNotValidCostState={setIsNotValidCostState}
        textTitle={t('SELL_ORDER_T.DELIVERY_COST_TITLE')}
      />
    )
  }
  const disableButtonOnclick = e => {
    e.target.disabled = true
  }
  const enableButtonOnclick = e => {
    e.target.disabled = false
    setSendingSubmit(false)
  }

  const handleSelectPickupInLockers = useCallback(value => {
    setIsPickupInLockers(value)
  }, [])

  const handleSelectLocker = useCallback(locker => {
    setLockerSelected(locker)
  }, [])

  const handleSelectSlot = useCallback(slot => {
    setSlotSelected(slot)
  }, [])

  const RetirementForm = () => {
    const handleChange = (field, value) => {
      setFormDataMerchandise(prev => ({
        ...prev,
        [field]: value,
      }))
    }

    const handlePhoneChange = number => {
      setFormDataMerchandise(prev => ({
        ...prev,
        phone: { number },
      }))
    }

    const isAnotherPerson = formDataMerchandise.retirement === 'isAnotherPerson'

    return (
      <>
        <div
          className="container-merchandise-elements"
          data-testid="container-merchandise-withdrawal">
          <span className="generic-merchandise-title">
            {t('RIGHT_SELECTION_MODAL.MERCHANDISE_WITHDRAWAL.TITLE')}
          </span>

          <label className="label-merchandise">
            <input
              type="radio"
              checked={formDataMerchandise.retirement === 'isCustomer'}
              onChange={() => handleChange('retirement', 'isCustomer')}
              data-testid="input-radio-withdrawal-customer"
            />
            <span className="merchandise-option-span">
              {t(
                'RIGHT_SELECTION_MODAL.MERCHANDISE_WITHDRAWAL.CUSTOMER_OPTION'
              )}
            </span>
          </label>

          <label className="label-merchandise">
            <input
              type="radio"
              checked={isAnotherPerson}
              onChange={() => handleChange('retirement', 'isAnotherPerson')}
              data-testid="input-radio-withdrawal-another-person"
            />
            <span className="merchandise-option-span">
              {t('RIGHT_SELECTION_MODAL.MERCHANDISE_WITHDRAWAL.ANOTHER_PERSON')}
            </span>
          </label>
        </div>

        {isAnotherPerson && (
          <div className="container-info-merchandise">
            <span className="merchandise-text-camp">
              {t('RIGHT_SELECTION_MODAL.MERCHANDISE_WITHDRAWAL.NAME_LASTNAME')}
            </span>
            <input
              className="input-merchandise"
              type="text"
              value={formDataMerchandise.fullName || ''}
              onChange={e => handleChange('fullName', e.target.value)}
              data-testid="input-withdrawal-fullname"
            />
          </div>
        )}

        <div className="container-info-merchandise">
          <span className="merchandise-text-camp">
            {!isCountedCustomer
              ? `${t(
                  'RIGHT_SELECTION_MODAL.MERCHANDISE_WITHDRAWAL.TELEPHONE_NUMBER'
                )}`
              : `${t(
                  'RIGHT_SELECTION_MODAL.MERCHANDISE_WITHDRAWAL.TELEPHONE_NUMBER'
                )}*`}
          </span>
          <PhoneNumberField
            value={formDataMerchandise.phone?.number}
            onChange={handlePhoneChange}
            data-testid="input-withdrawal-phone"
            optional={!isCountedCustomer}
          />
        </div>

        <div className="container-info-merchandise">
          <span className="merchandise-text-camp">
            {t('RIGHT_SELECTION_MODAL.MERCHANDISE_WITHDRAWAL.EXTRA_DETAILS')}
          </span>
          <textarea
            className="comment-merchandise"
            value={formDataMerchandise.comment || ''}
            onChange={e => handleChange('comment', e.target.value)}
            data-testid="input-withdrawal-comment"
          />
        </div>
      </>
    )
  }

  return (
    <>
      {sendingSubmit && <Loading full />}
      {open ? (
        <Container
          className={'dispatch-type-navbar-container'}
          data-testid="modal-set-location">
          <Row className="no-margin-nopadding col-distribute-container">
            <Row className="no-margin-nopadding client-detail-forms-distribution">
              <Row className="no-margin-nopadding">
                <Col className="dispatch-type-close">
                  <h2
                    className="dispatch-type-title"
                    data-testid="container-modal-title">
                    {t('RIGHT_SELECTION_MODAL.SELECT_INVENTORY_TYPE')}
                  </h2>
                  <img
                    src={no}
                    alt="close-icon"
                    className="close-icon-dispach-menu"
                    onClick={closeBar}
                    data-testid="btn-close-modal"
                  />
                </Col>
                <hr />
              </Row>
              <Row>
                <Col>{validateDirectDelivery()}</Col>
              </Row>
              {renderDeliveryMethodButtons()}
              {deliveryMethodState === 'DEL' ? (
                <>
                  <div className="add-sucursal-superior-margin">
                    {renderGenericMultipleSelectForm({
                      title: t('RIGHT_SELECTION_MODAL.SELECT_BILLING_BRANCH'),
                      showState: openDropdown.selectBranchOffice,
                      setShowState: state =>
                        setOpenDropdown({
                          ...openDropdown,
                          selectBranchOffice: state,
                        }),
                      valueState: sucState,
                      setValueState: setSucState,
                      mappedInfo: branchesData,
                      placeholder: t(
                        'RIGHT_SELECTION_MODAL.BRANCH_PLACEHOLDER'
                      ),
                      controlValue: 'SUC',
                      showSearch: true,
                    })}
                  </div>
                  {customerSavedLocations?.CustomerType?.CustomerTypeId ===
                  customerTypeId.natural
                    ? customerSavedLocations.AddressList?.length > 0
                      ? renderLocation(customerSavedLocations?.AddressList)
                      : null
                    : customerSavedLocations?.AdministrativeStoreInfo
                        ?.AddressList?.length > 0
                    ? renderLocation(
                        customerSavedLocations?.AdministrativeStoreInfo
                          .AddressList
                      )
                    : customerSavedLocations?.AddressList?.length > 0
                    ? renderLocation(customerSavedLocations?.AddressList)
                    : null}
                  {isCountedCustomer &&
                  customerSavedLocations?.AddressList?.length
                    ? null
                    : renderAddMoreLocation()}
                  {renderOAError()}
                  <div className="add-delivery-superior-margin">
                    {renderVADDatePickerBox(
                      t('RIGHT_SELECTION_MODAL.SET_DELIVERY_DATE_TITLE'),
                      deliveryDateState,
                      setDeliveryDateState
                    )}
                  </div>

                  <div className="add-delivery-superior-margin">
                    {/* {validateDirectDelivery()} */}
                  </div>
                  {fullfilmentResponse &&
                  fullfilmentResponse?.Data?.length > 0 ? (
                    <div className="add-delivery-superior-margin">
                      {renderGenericMultipleSelectForm({
                        title: t('RIGHT_SELECTION_MODAL.SELECT_DELIVERY_TYPE'),
                        showState: openDropdown.dispatchTypeDomicile,
                        setShowState: state =>
                          setOpenDropdown({
                            ...openDropdown,
                            dispatchTypeDomicile: state,
                          }),
                        valueState: deliveryTypeState,
                        setValueState: setDeliveryTypeState,
                        mappedInfo: isDirectDelivery
                          ? fullfilmentResponse.Data.filter(
                              f =>
                                f.FulfillmentPlanId === directDeliveryD1 ||
                                f.FulfillmentPlanId === directDelivertSupplier
                            )
                          : fullfilmentResponse.Data.filter(
                              f =>
                                f.FulfillmentPlanId !== directDelivertSupplier
                            ),
                        placeholder: t(
                          'RIGHT_SELECTION_MODAL.SELECT_DELIVERY_METHOD'
                        ),
                        controlValue: 'DEL',
                        blockComboBox: isDirectDelivery,
                      })}
                    </div>
                  ) : null}
                  {isDirectDelivery && (
                    <div className="select-supplier">
                      <DynamicSelector
                        title={'RIGHT_SELECTION_MODAL.CHOOSE_SUPPLIER'}
                        showState={openDropdown.selectSupplier}
                        setShowState={state =>
                          setOpenDropdown({
                            ...openDropdown,
                            selectSupplier: !openDropdown.selectSupplier,
                          })
                        }
                        valueState={supplier}
                        placeholder={'RIGHT_SELECTION_MODAL.SELECT_SUPPLIER'}
                        mappedInfo={supplierProduct}
                        controlValue={'SUPPLIER'}
                        setValueState={setSupplier}
                        loading={loadingSupplierProducts}></DynamicSelector>
                    </div>
                  )}
                  {isCountedCustomer && RetirementForm()}
                </>
              ) : (
                <>
                  <div className="add-sucursal-superior-margin">
                    {renderGenericMultipleSelectForm({
                      title: t('RIGHT_SELECTION_MODAL.SELECT_BILLING_BRANCH'),
                      showState: openDropdown.selectBranchOffice,
                      setShowState: state =>
                        setOpenDropdown({
                          ...openDropdown,
                          selectBranchOffice: !openDropdown.selectBranchOffice,
                        }),
                      valueState: sucState,
                      setValueState: setSucState,
                      mappedInfo: branchesData,
                      placeholder: t(
                        'RIGHT_SELECTION_MODAL.BRANCH_PLACEHOLDER'
                      ),
                      controlValue: 'SUC',
                      showSearch: true,
                    })}
                    <p className="message-billing-branch">
                      {t('RIGHT_SELECTION_MODAL.MESSAGE_BILLING_BRANCH')}
                    </p>
                  </div>
                  {canPickupInLockers && (
                    <Locker
                      onSelectPickupInLockers={handleSelectPickupInLockers}
                      onSelectLocker={handleSelectLocker}
                      onSelectSlot={handleSelectSlot}
                      showLocker={showLocker}
                      renderSelector={renderGenericMultipleSelectForm}
                    />
                  )}
                  <div className="add-delivery-superior-margin">
                    {renderVADDatePickerBox(
                      t('RIGHT_SELECTION_MODAL.SELECT_DELIVERY_DATE'),
                      deliveryDateState,
                      setDeliveryDateState
                    )}
                  </div>

                  {fullfilmentResponse &&
                  fullfilmentResponse?.Data?.length > 0 ? (
                    <div className="add-delivery-superior-margin">
                      {renderGenericMultipleSelectForm({
                        title: t('RIGHT_SELECTION_MODAL.SELECT_DELIVERY_TYPE'),
                        showState: openDropdown.dispatchTypeBranchOffice,
                        setShowState: state =>
                          setOpenDropdown({
                            ...openDropdown,
                            dispatchTypeBranchOffice:
                              !openDropdown.dispatchTypeBranchOffice,
                          }),
                        valueState: deliveryTypeState,
                        setValueState: setDeliveryTypeState,
                        mappedInfo: isDirectDelivery
                          ? fullfilmentResponse.Data
                          : fullfilmentResponse.Data.filter(
                              f =>
                                f.FulfillmentPlanId !== directDelivertSupplier
                            ),
                        placeholder: t(
                          'RIGHT_SELECTION_MODAL.SELECT_DELIVERY_METHOD'
                        ),
                        controlValue: 'DEL',
                        blockComboBox: isDirectDelivery,
                      })}
                    </div>
                  ) : (
                    <div className="add-delivery-superior-margin">
                      <label className="add-delivery-error-on-loading">
                        {t('RIGHT_SELECTION_MODAL.ERROR_TYPE_DELIVERY_LABEL')}
                      </label>
                    </div>
                  )}
                  {RetirementForm()}
                </>
              )}
            </Row>
            <Row className="generate-dispatch-button-distribution">
              <Col className="generate-dispatch-button-container">
                <button
                  className="generate-dispatch-button-footer"
                  disabled={isButtonDisabled}
                  onClick={e => {
                    setSendingSubmit(true)
                    disableButtonOnclick(e)
                    checkPreorderValidations(e)
                  }}
                  data-testid="btn-generate-dispatch">
                  {oaLoading && deliveryMethodState === 'DEL' ? (
                    <CircularProgress size={20} />
                  ) : (
                    t('RIGHT_SELECTION_MODAL.GENERATE_DISPATCH_BUTTON')
                  )}
                </button>
              </Col>
            </Row>
          </Row>
        </Container>
      ) : null}
      <CustomSnackbar
        open={snackbarMessage.open}
        message={snackbarMessage.message}
        severity={snackbarMessage.severity}
        onClose={handleClose}
      />
      <ModalAlertGeneric
        isError={
          isErrorDispatchModal ||
          isErrorComercialCreditModal ||
          isErrorLimitCreditModal
        }
        setIsError={v => {
          if (isErrorDispatchModal) setIsErrorDispatchModal(v)
          else if (isErrorLimitCreditModal) setIsErrorLimitCreditModal(v)
          else setIsErrorComercialCreditModal(v)
          if (!v) handleOpen(false)
        }}
        messageSettings={
          isErrorDispatchModal
            ? messageDispatchModal
            : isErrorLimitCreditModal
            ? isErrorMessageLimitCreditModal
            : isErrorMessageComercialCreditModal
        }
        setMessageSettings={
          isErrorDispatchModal
            ? setMessageDispatchModal
            : isErrorLimitCreditModal
            ? setIsErrorMessageLimitCreditModal
            : setIsErrorMessageComercialCreditModal
        }
        isButtonClose={isErrorComercialCreditModal}
      />
      <ModalAlertGeneric
        isError={isErrorCompanyOrWarehouse}
        setIsError={v => {
          setIsErrorCompanyOrWarehouse(v)
          if (!v) handleOpen(false)
        }}
        messageSettings={{
          message:
            'La compañía o sucursal seleccionada no contiene datos válidos. Por favor, intente nuevamente.',
          status: 'error',
        }}
        setMessageSettings={() => {}}
      />
      {onValidatePreOrderModals()}
      {onCostsModal()}
      {onInvalidProductModal()}
    </>
  )
}

export default RightSetLocationModal
